import {Component, OnInit} from '@angular/core';
import {UserRepository} from "../states/user.repository";
import {PanelModule} from "primeng/panel";
import {User} from "../models/user.model";
import {InputTextModule} from "primeng/inputtext";
import {ButtonModule} from "primeng/button";
import {FormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {ToastService} from "../../../shared/services/toast.service";

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  imports: [
    PanelModule,
    InputTextModule,
    ButtonModule,
    FormsModule,
    CommonModule
  ],
  standalone: true
})
export class ProfileComponent implements OnInit {
  activeUser: User | undefined;
  newDisplayName: string = '';
  isSaving: boolean = false;

  constructor(
    private readonly userRepository: UserRepository,
    private readonly toastService: ToastService,
  ) {
  }

  ngOnInit() {
    this.userRepository.getActiveUser().subscribe((user) => {
      this.activeUser = user;
      this.newDisplayName = user?.displayName || user?.name || '';
    });
  }

  saveDisplayName() {
    if (!this.activeUser?.id || !this.newDisplayName.trim()) {
      return;
    }
    this.isSaving = true;
    this.userRepository.updateDisplayName(this.activeUser.id, this.newDisplayName.trim()).subscribe({
      next: () => {
        this.toastService.showSuccess('Anzeigename erfolgreich aktualisiert');
        this.isSaving = false;
      },
      error: () => {
        this.toastService.showError('Fehler beim Aktualisieren des Anzeigenamens');
        this.isSaving = false;
      }
    });
  }
}
